"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withConfigConsumer = exports.ConfigConsumer = exports.ConfigContext = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var renderEmpty_1 = tslib_1.__importDefault(require("./renderEmpty"));
var defaultGetPrefixCls = function (suffixCls, customizePrefixCls) {
    if (customizePrefixCls) {
        return customizePrefixCls;
    }
    return suffixCls ? "anq-".concat(suffixCls) : 'anq';
};
exports.ConfigContext = React.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: defaultGetPrefixCls,
    renderEmpty: renderEmpty_1.default,
});
exports.ConfigConsumer = exports.ConfigContext.Consumer;
/** @deprecated Use hooks instead. This is a legacy function */
function withConfigConsumer(config) {
    return function withConfigConsumerFunc(Component) {
        // Wrap with ConfigConsumer. Since we need compatible with react 15, be care when using ref methods
        var SFC = (function (props) { return (React.createElement(exports.ConfigConsumer, null, function (configProps) {
            var basicPrefixCls = config.prefixCls;
            var getPrefixCls = configProps.getPrefixCls;
            var customizePrefixCls = props.prefixCls;
            var prefixCls = getPrefixCls(basicPrefixCls, customizePrefixCls);
            return React.createElement(Component, tslib_1.__assign({}, configProps, props, { prefixCls: prefixCls }));
        })); });
        var cons = Component.constructor;
        var name = (cons && cons.displayName) || Component.name || 'Component';
        SFC.displayName = "withConfigConsumer(".concat(name, ")");
        return SFC;
    };
}
exports.withConfigConsumer = withConfigConsumer;
//# sourceMappingURL=context.js.map